import * as React from "react"

import { cn } from "@/lib/utils"

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          // Match Input: green `input-focus`, not black `primary` (AI Agents System Prompt, etc.)
          "flex min-h-[80px] w-full max-w-full rounded-md border border-input bg-background px-3 py-2 text-sm placeholder:text-muted-foreground hover:border-[hsl(151_74%_75%)] focus:outline-none focus:ring-1 focus:ring-input-focus focus:border-input-focus focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-input-focus focus-visible:border-input-focus disabled:cursor-not-allowed disabled:opacity-50 transition-colors overflow-auto break-words [overflow-wrap:anywhere]",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
